import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import RosterPage from "../pages/roster/page";
import EventsPage from "../pages/events/page";
import ShopPage from "../pages/shop/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/roster",
    element: <RosterPage />,
  },
  {
    path: "/events",
    element: <EventsPage />,
  },
  {
    path: "/shop",
    element: <ShopPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
